const collectingMoney = () => import('@/pages/collectingMoney/index')
const createCollectMoney = () => import('@/pages/collectingMoney/createCollectMoney')
const collectMoneyDetail = () => import('@/pages/collectingMoney/collectMoneyDetail')
const extraCharge = () => import('@/pages/extraCharge')

export default [{
  path: '/collectingMoney',
  name: '/collectingMoney',
  component: collectingMoney,
  meta: {
    storeKey: 'trs.collectingMoney'
  }
},
{
  path: '/extraCharge',
  name: 'extraCharge',
  component: extraCharge,
  meta: {}
},
{
  path: '/collectMoneyDetail',
  name: '/collectMoneyDetail',
  component: collectMoneyDetail,
  meta: {
  }
},
{
  path: '/createCollectMoney',
  name: '/createCollectMoney',
  component: createCollectMoney,
  meta: {
  }
}
]



// WEBPACK FOOTER //
// ./src/router/collectingMoney/index.js